
<template>
  <b-row
    class="mr-md-5 ml-md-5 align-items-center justify-content-center no-gutters"
  >
    <b-col cols="12">
      <h1 class="text-color-dark pl-3" style="font-size: 1.5rem">
        Explore the topics that are shaping the future of technology with our
        tracks! <br />
        <br />
        Enhance your experience in...
      </h1>
    </b-col>
    <b-col
      class="col-6 col-md-4 col-lg-3 mt-1 mt-md-3 d-flex justify-content-center"
      v-for="(image, imageIndex) in itemsThumbnails"
      :key="imageIndex"
    >
      <!--         @mouseover="hoverIndex = imageIndex"
        @mouseleave="hoverIndex = ''" -->
      <div
        v-b-tooltip.click.blur.html="tipData"
        tabindex="0"
        title="Speakers and sessions will available soon"
        @click="handleRouting(image.tag)"
        class="myBlock d-flex justify-content-center align-items-center flex-wrap"
        style="cursor: pointer"
        :style="{
          'background-image':
            'url(' + (hoverIndex === imageIndex ? image.altbg : image.bg) + ')',
        }"
      >
        <b-img :id="imageIndex" class="icon-image" :src="image.src"></b-img>
        <strong
          class="text-center w-100 text-light track"
          style="text-transform: uppercase"
          >{{ image.name ? image.name : image.tag }}</strong
        >
      </div>
    </b-col>
  </b-row>
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import { helperMethods } from "../mixins/helpers";

export default {
  components: {
    CoolLightBox,
  },
  mixins: [helperMethods],
  data() {
    return {
      hoverIndex: "",
      tipData: {
        title:
          "<span style='color: white !important; font-weight: 300;'> Sessions are coming soon. <a  style='color: white !important; font-weight: 300; ' href='#mc-embedded-subscribe-form'>Subscribe to our newsletter to get notified. </a> </span>",
      },
      items: [
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio style?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047013/2024/Architecture_3x.png",
          tag: "Architecture",
          id: "1",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637812/2024/red_box-1.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185342/2024/Architecture.png",
        },
        {
          title: "a beautiful mountain view",
          description: "Photo by Facundo",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047012/2024/Cloud_3x.png",
          tag: "Cloud/DevOps",
          id: "5",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637809/2024/blue_box-2.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185342/2024/Cloud.png",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?o",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047012/2024/Data_3x.png",
          tag: "Data",
          name: "Data",
          id: "3",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637813/2024/yellow_box-3.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185342/2024/Data.png",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047012/2024/AI_3x.png",
          tag: "AI",
          name: "AI",
          id: "7",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637809/2024/green_box-4.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185342/2024/AI.png",
        },
        {
          title: "a beautiful mountain view",
          description: "Photo by Facundo",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047012/2024/JVM_3x.png",
          tag: "JVM",
          id: "4",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637811/2024/pink_box-5.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185342/2024/JVM.png",
        },
        {
          title: "a beautiful mountain view",
          description: "Photo by Facundo",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047013/2024/leadership_3x.png",
          tag: "Leadership-Management",
          id: "2",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637812/2024/red_box-6.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185346/2024/Leadership.png",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047012/2024/Quality_3x.png",
          tag: "Quality-Test",
          name: "Quality & Test",
          id: "7",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637810/2024/blue_box-7.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185346/2024/Quality_test.png",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047013/2024/Security_3x.png",
          tag: "Security",
          id: "9",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637813/2024/yellow_box-8.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185346/2024/Security.png",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047012/2024/Off_track_3x.png",
          tag: "OFF-Track",
          name: "OFF track",
          id: "11",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637810/2024/green_box-9.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185346/2024/off-track.png",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047013/2024/Web_3x.png",
          tag: "Web",
          id: "8",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637811/2024/pink_box-10.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185346/2024/Web.png",
        },

        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047013/2024/Keynote_3x.png",
          name: "Keynotes",
          tag: "Keynote",
          id: "kw",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637814/2024/red_box-11.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185342/2024/keynote.png",
        },

        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1712047013/2024/Net_3x.png",
          tag: "NET",
          name: ".Net",
          id: "10",
          bg: "https://res.cloudinary.com/oredev/image/upload/v1711637810/2024/blue_box-12.png",
          altbg:
            "https://res.cloudinary.com/oredev/image/upload/v1713185346/2024/net.png",
        },
      ],
      index: null,
    };
  },

  methods: {
    handleRouting(tag) {
      this.$store.dispatch("showeffect", true);
      setTimeout(() => {
        this.$store.dispatch("showeffect", false);
      }, 10000);
      this.$router.push("/line-up?tags=" + tag);
    },
  },

  computed: {
    itemsThumbnails() {
      return this.items;
      return this.items.map((e) => {
        const url = this.$_addToUrl(e.src, "");
        const obj = {
          title: e.title,
          description: e.description,
          name: e.name,
          src: url,
          tag: e.tag,
          bg: e.bg,
          bg: e.altbg,
        };
        return obj;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.image:hover {
  cursor: pointer;
}
.icon-image {
  margin-left: auto;
  margin-right: auto;
  width: 100px;
  height: 100px;
}

.myBlock {
  border-radius: 30px;
  background-size: cover;
  padding: 20px;
  margin: 0px;
  width: 204px;
  height: 204px;
  //cursor: pointer;
  border: 3px solid rgba(0, 0, 0, 0);
}
@media screen and (max-width: 1200px) {
  .myBlock {
    width: 142px;
    height: 142px;
    font-size: 0.9rem;
  }
  .icon-image {
    width: 70px;
    height: 70px;
  }
}

.myBlock:hover {
  //cursor: pointer;
  transition: all 0.1s ease;
}

.track {
  font-weight: 300;
}

@media screen and (max-width: 767px) {
  .overflow-ellipsis {
    -webkit-line-clamp: 5; /* number of lines to show */
    line-clamp: 5;
  }
  .myBlock {
    width: 155px;
  }
  .icon-image {
    width: 77px;
    height: 76px;
  }
  strong {
    font-size: 11px;
  }
  .track {
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue